module.exports = __webpack_public_path__ + "img/hero-intelligentPDF.0a4083ea.png";